import { gql } from '@apollo/client';

export default gql`
  mutation createBranch(
    $foundationId: String
    $temp: String
    $users: Int
    $smss: Int
    $emails: Int
    $username: String
    $password: String
    $name: String
    $nameAr: String
    $logo: String
    $tel1: String
    $tel2: String
    $fax: String
    $mob: String
    $email: String
    $website: String
    $address: String
    $poBox: String
    $CR: String
    $city: String
    $country: String
    $location: LocationInput
    $photos: String
    $locationLink: String
    $note: String
  ) {
    createBranch(
      foundationId: $foundationId
      temp: $temp
      users: $users
      smss: $smss
      emails: $emails
      username: $username
      password: $password
      name: $name
      nameAr: $nameAr
      logo: $logo
      tel1: $tel1
      tel2: $tel2
      fax: $fax
      mob: $mob
      email: $email
      website: $website
      address: $address
      poBox: $poBox
      CR: $CR
      city: $city
      country: $country
      location: $location
      locationLink: $locationLink
      photos: $photos
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
